import script from "./TagNameCellElementLite.vue?vue&type=script&setup=true&lang=ts"
export * from "./TagNameCellElementLite.vue?vue&type=script&setup=true&lang=ts"

import "./TagNameCellElementLite.vue?vue&type=style&index=0&id=63351b2f&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63351b2f"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
